import { render } from "./property-mortgage.vue?vue&type=template&id=20be37c7"
import script from "./property-mortgage.js?vue&type=script&lang=js"
export * from "./property-mortgage.js?vue&type=script&lang=js"

import "./property-mortgage.vue?vue&type=style&index=0&id=20be37c7&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__